import {BorderRestDto, BorderSideRestDto} from "@/api/pharma-cms-content-page/models";
import {BorderSideRestDtoModel} from "@/models/api/pharma-cms-content-page/BorderSideRestDtoModel";

export class BorderRestDtoModel implements BorderRestDto {
    top?: BorderSideRestDto | null;
    right?: BorderSideRestDto | null;
    bottom?: BorderSideRestDto | null;
    left?: BorderSideRestDto | null;

    constructor() {
    }

    static createWithDefaults(): BorderRestDtoModel {
        return new this();
    }

    static cloneFrom(source: BorderRestDto): BorderRestDtoModel {
        const clone: BorderRestDtoModel = new this();

        clone.top = source.top
            ? BorderSideRestDtoModel.cloneFrom(source.top)
            : null;
        clone.right = source.right
            ? BorderSideRestDtoModel.cloneFrom(source.right)
            : null;
        clone.bottom = source.bottom
            ? BorderSideRestDtoModel.cloneFrom(source.bottom)
            : null;
        clone.left = source.left
            ? BorderSideRestDtoModel.cloneFrom(source.left)
            : null;

        return clone;
    }

    /**
     * No side carries anything, so there is no border to speak of.
     *
     * A column without a border comes back from the API as four sides with null members rather
     * than as a null border, and that object is indistinguishable from a real one by its presence
     * alone. Hosts use this to tell the two apart; without it the border group would open on every
     * column that never had a border, with a colour it demands but has nothing to show.
     */
    static isEmpty(source?: BorderRestDto | null): boolean {
        if (!source) {
            return true;
        }

        return [source.top, source.right, source.bottom, source.left]
            .every((side?: BorderSideRestDto | null) => BorderSideRestDtoModel.isEmpty(side));
    }
}
